import { render, staticRenderFns } from "./NormalComposableCheckpoint.vue?vue&type=template&id=4497bc28&scoped=true&"
import script from "./NormalComposableCheckpoint.vue?vue&type=script&lang=js&"
export * from "./NormalComposableCheckpoint.vue?vue&type=script&lang=js&"
import style0 from "./NormalComposableCheckpoint.vue?vue&type=style&index=0&id=4497bc28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497bc28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4497bc28')) {
      api.createRecord('4497bc28', component.options)
    } else {
      api.reload('4497bc28', component.options)
    }
    module.hot.accept("./NormalComposableCheckpoint.vue?vue&type=template&id=4497bc28&scoped=true&", function () {
      api.rerender('4497bc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/Checkpoints/NormalComposableCheckpoint.vue"
export default component.exports